import { ValidateUtils } from 'utils';
import ValidateInvoice from '../InvoiceInfoModal/validateForm';

const validateForm = (
  {
    customerName,
    customerPhone,
    customerEmail,
    customerShippingAddress,
    customerProvinceCode,
    customerDistrictCode,
    customerWardCode,
    totalWard,
    invoice,
  },
  onSetError,
  translateAlertAction,
) => {
  if (ValidateUtils.isEmpty(customerName)) {
    onSetError('name', true);
    throw new Error(translateAlertAction('message_not_input_name'));
  }

  if (ValidateUtils.isEmpty(customerPhone)) {
    onSetError('phone', true);
    throw new Error(translateAlertAction('message_not_input_phone'));
  }

  if (!ValidateUtils.validatePhone(customerPhone)) {
    onSetError('phone', true);
    throw new Error(translateAlertAction('message_correct_phone_number_format'));
  }

  if (!ValidateUtils.isEmpty(customerEmail) && !ValidateUtils.validateEmail(customerEmail)) {
    onSetError('email', true);
    throw new Error(translateAlertAction('message_invalid_email'));
  }
  if (ValidateUtils.isEmpty(customerShippingAddress)) {
    onSetError('address', true);
    throw new Error(translateAlertAction('message_not_input_address'));
  }

  if (customerProvinceCode === '0') {
    throw new Error(translateAlertAction('message_you_have_not_selected_province_City'));
  }

  if (customerDistrictCode === '0') {
    throw new Error(translateAlertAction('message_you_have_not_selected_the_district'));
  }

  if (customerWardCode === '0' && totalWard > 0) {
    throw new Error(translateAlertAction('message_you_have_not_selected_province_City'));
  }

  const { invoiceRequest, email } = invoice || {};
  // validate invoice
  if (invoiceRequest === undefined) {
    onSetError('invoiceRequest', true);
    throw Error(translateAlertAction('message_empty_is_invoice_request'));
  }

  if (invoice && invoiceRequest) {
    ValidateInvoice({ ...invoice, translateAlertAction, onSetError });

    if (ValidateUtils.isEmpty(email)) {
      const emailElement = document.getElementById('email');
      if (emailElement) {
        emailElement.focus();
      }
      onSetError('email', true);
      throw new Error(translateAlertAction('require_email_when_request_tax_invoice'));
    }

    if (!ValidateUtils.validateAsciiEmail(email)) {
      onSetError('email', true);
      throw new Error(translateAlertAction('message_invalid_email'));
    }

    if (!ValidateUtils.isDigits(invoice.postCode)) {
      const postCodeElement = document.getElementById('postCode');
      if (postCodeElement) {
        postCodeElement.focus();
      }
      onSetError('postCode', true);
      throw new Error(translateAlertAction('message_post_code_must_be_entered'));
    }

    if (!ValidateUtils.validatePostcode(invoice.postCode, 5)) {
      onSetError('postCode', true);
      throw new Error(translateAlertAction('message_post_code_invalid'));
    }
  }
};

export default validateForm;
